import { render, staticRenderFns } from "./RequestMorePODetail.vue?vue&type=template&id=63643b70&scoped=true"
import script from "./RequestMorePODetail.vue?vue&type=script&lang=js"
export * from "./RequestMorePODetail.vue?vue&type=script&lang=js"
import style0 from "./RequestMorePODetail.vue?vue&type=style&index=0&id=63643b70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63643b70",
  null
  
)

export default component.exports